import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rec-date-range" };
const _hoisted_2 = {
    key: 1,
    class: "rec-date-range__date-pickers"
};
import { computed, inject, ref, watch } from "vue";
// Components
import RecCalendar from "@/common/components/RecCalendar.vue";
import RecSelect from "@/common/components/RecSelect.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecDateRange',
    props: /*@__PURE__*/ _mergeModels({
        customLabel: {},
        noneLabel: {},
        excludeSelect: { type: Boolean }
    }, {
        "startdate": {},
        "startdateModifiers": {},
        "enddate": {},
        "enddateModifiers": {},
    }),
    emits: ["update:startdate", "update:enddate"],
    setup(__props) {
        const i18n = inject("i18n");
        const props = __props;
        const startDate = _useModel(__props, "startdate");
        const endDate = _useModel(__props, "enddate");
        const menuOpen = ref(false);
        const customDate = ref(!!startDate.value || !!endDate.value || props.excludeSelect);
        const options = [
            {
                options: [
                    { label: props.noneLabel ?? i18n.t("All Time"), value: false },
                    { label: props.customLabel ?? i18n.t("Custom"), value: true }
                ]
            }
        ];
        const label = computed(() => {
            return customDate.value ? props.customLabel || i18n.t("Custom") : props.noneLabel || i18n.t("All Time");
        });
        watch(customDate, (newValue) => {
            menuOpen.value = false;
            if (!newValue) {
                startDate.value = undefined;
                endDate.value = undefined;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!props.excludeSelect)
                    ? (_openBlock(), _createBlock(RecSelect, {
                        key: 0,
                        modelValue: customDate.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customDate).value = $event)),
                        menu: menuOpen.value,
                        "onUpdate:menu": _cache[1] || (_cache[1] = ($event) => ((menuOpen).value = $event)),
                        options: options,
                        label: label.value
                    }, null, 8, ["modelValue", "menu", "label"]))
                    : _createCommentVNode("", true),
                (customDate.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(RecCalendar, {
                            modelValue: startDate.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((startDate).value = $event)),
                            "icon-display": "input",
                            "max-date": endDate.value,
                            placeholder: _ctx.$t('Start Date')
                        }, null, 8, ["modelValue", "max-date", "placeholder"]),
                        _createVNode(RecCalendar, {
                            modelValue: endDate.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((endDate).value = $event)),
                            "icon-display": "input",
                            "min-date": startDate.value,
                            placeholder: _ctx.$t('End Date')
                        }, null, 8, ["modelValue", "min-date", "placeholder"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
